<span>{{ 'Query::IndexingAbortedNotification' | abpLocalization: queryName }}</span>
